import * as moment from "moment-timezone";
import * as React from "react";
import styled from "styled-components";

import HtmlBody from "src/library/components/Notes/HtmlBody";
import { IUser } from "src/core/users/api/users.api";

import {
  OrderMode,
  IOrderNote
} from "../api/orders.api";

interface OrderNoteProps {
  orderMode: OrderMode;
  note: IOrderNote;
  user?: IUser;
}

const OrderNote: React.ReactFCWithChildren<OrderNoteProps> = props => {
  return (
    <Container>
      <NoteWrapper>
        {props.user && (
          <SubText>
            {props.user.email}
          </SubText>
        )}

        <HtmlBody body={props.note.body} />

        <SubText>
          {`Updated by ${props.note.source} at ${moment
            .utc(props.note.updatedAt)
            .local()
            .format("HH:mm DD/MM/YY")}`}
        </SubText>
      </NoteWrapper>
    </Container>
  );
};

const Container = styled.div`
  margin-top: ${({ theme }) => theme.spacing.margins.md};
  background: ${({ theme }) => theme.colors.lightestGrey};
  padding: ${({ theme }) => theme.spacing.padding.md};
  width: 100%;
  position: relative;

  &:first-child {
    margin-top: 0;
  }
`;

const NoteWrapper = styled.div`
  width: 100%;
`;

// const ActionWrapper = styled.div`
//   position: absolute;
//   top: 15px;
//   right: 15px;
//   .delete-icon {
//     margin-left: ${({ theme }) => theme.spacing.margins.sm};
//   }
// `;

const SubText = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.sub};
  padding-top: ${({ theme }) => theme.spacing.padding.md};
`;

export default OrderNote;
